import React, { useState } from "react";
import toast from "react-hot-toast";
import { Button, Spinner } from "flowbite-react";

import useSize from "../../../../../Utils/useSize/useSize";
import Header from "./Header";
import Backend from "../../../../../Backend/Backend";

const backend = await new Backend().init();

export default function AddMsg(props) {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [msg, setMsg] = useState("");

  const EditMsg = () => {
    if (msg == "") {
      toast.error("Invalid Message ");
    } else {
      setLoading(true);
      let data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        msg: msg,
      };

      backend.add_message(data).then((r) => {
        setLoading(false);
        if (r.error == "False") {
          toast.success(r.message);
          props.reload();
          props.close();
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  return (
    <div
      className="background border primary-border"
      style={{
        width: windowSize[0] / 3,
        height: windowSize[1] / 3,
        borderRadius: 10,
      }}
    >
      <Header close={props.close} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: 70,
            marginBottom: 10,
            flexDirection: "column",
            marginTop: 20,
          }}
        >
          <div style={{ display: "flex" }}>
            <label for="message" class="label marginright bold flex">
              ENTER MESSAGE
            </label>
          </div>
          <input
            type="text"
            name="message"
            id="message"
            role="presentation"
            autoComplete="new-password"
            style={{ width: windowSize[0] / 4, marginTop: 5 }}
            class="label input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            placeholder="Enter Msg"
            value={msg}
            onChange={(e) => {
              setMsg(e.target.value);
            }}
          />
        </div>

        <Button
          onClick={!loading ? EditMsg : null}
          className="w-full mt-2 max-w-sm text-white font-semibold !bg-[var(--primary)] hover:brightness-90 focus:ring-0 focus:outline-none transition-all rounded-lg flex items-center justify-center text-center"
        >
          <div className="flex items-center justify-center gap-2">
            {loading && <Spinner size="sm" />}
            {!loading && "SUBMIT"}
          </div>
        </Button>
      </div>
    </div>
  );
}
